module.exports = __webpack_public_path__ + "static/media/earthArrowRight_active.f6bff4a8.svg";